import React from "react";
import { BoxWrapper, Box } from "./DesignedFlatBox.style.js";

const DesignedFlatBox = (props) => {
	let { className, indicators, outsideTopElements, outsideBottomElements, disableInnerShadow, borderColor, ...rest } = props;
	return (
		<BoxWrapper className={(className || "") + " box text-center"} {...rest}>
			{outsideTopElements}

			<Box className="inner-box" borderColor={borderColor} disableInnerShadow={disableInnerShadow}>
				{props.children}
			</Box>
		</BoxWrapper>
	);
};

export default DesignedFlatBox;
